import { ReactElement, useRef } from 'react';
import styled from 'styled-components';

import { Address } from '@dreryk/address-common-api';

import { addressFormatter } from '@dreryk/react-common';
import { createDynamicColumnsWidth, RowDetails, RowDetailsCell } from '@dreryk/react-components';

import { DocplannerAddressRowDetailsFacilityDescription } from './DocplannerAddressRowDetailsFacilityDescription';

type DocplannerFacilityRowDetailsProps = {
   readonly externalAddressId: string;
   readonly externalAddressName: string;
   readonly externalFacilityAddress: string;
   readonly facilityName: string | undefined;
   readonly facilityAddress: Address | undefined;
};

const StyledRowDetails = styled(RowDetails)`
   padding-left: 80px;
`;

export const DocplannerAddressRowDetails = (props: DocplannerFacilityRowDetailsProps): ReactElement => {
   const { current: columnsWidth } = useRef(
      createDynamicColumnsWidth({
         leftPadding: '80px',
         nameAndAddress: '50%',
         eGabinetAssociation: '50%',
         rightPadding: '186px',
      })
   );
   return (
      <StyledRowDetails testId={props.externalAddressId}>
         <RowDetailsCell width={columnsWidth.nameAndAddress} testId={'nameAndAddress'}>
            <DocplannerAddressRowDetailsFacilityDescription
               facilityName={props.externalAddressName}
               facilityAddress={props.externalFacilityAddress}
            />
         </RowDetailsCell>
         <RowDetailsCell width={columnsWidth.eGabinetAssociation} testId={'eGabinetAssociation'}>
            {props.facilityName && props.facilityAddress ? (
               <DocplannerAddressRowDetailsFacilityDescription
                  facilityName={props.facilityName}
                  facilityAddress={addressFormatter(props.facilityAddress) ?? ''}
               />
            ) : (
               <span>{'-'}</span>
            )}
         </RowDetailsCell>
      </StyledRowDetails>
   );
};
